import { Button, Container, Typography } from '@app/components';
import { useTranslation } from 'react-i18next';
import { useCurrentLanguage } from '@app/i18n/useCurrentLanguage';
import { getCookiePolicyUrl } from '@app/i18n/cookiePolicy.utils';

export const AccountCookiePreferences: React.FC = () => {
  const { t } = useTranslation();
  const language = useCurrentLanguage();

  return (
    <Container className="flex flex-col gap-6 p-6 lg:rounded-xl">
      <Typography variant="m" className="font-bold">
        {t('account.sectionCookies.title')}
      </Typography>
      <Typography variant="s">{t('account.sectionCookies.description')}</Typography>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <Button
          onClick={() => {
            if (typeof window.tqConsent !== 'undefined') {
              window.tqConsent.open();
            }
          }}
          color="secondary"
          variant="outlined"
          className="w-[220px]"
        >
          {t('account.sectionCookies.manageButton')}
        </Button>
        <a
          className="text-s font-semibold text-accept-dark-blue"
          href={getCookiePolicyUrl(language)}
          target="_blank"
          rel="noreferrer"
        >
          {t('account.sectionCookies.policyLink')}
        </a>
      </div>
    </Container>
  );
};
